import { MantineThemeOverride } from '@mantine/core';

export type RingProgressTheme = NonNullable<MantineThemeOverride['components']>['RingProgress'];

export const RingProgress: RingProgressTheme = {
  // todo: define
};
